import { connect } from 'react-redux';
import SchoolSelectorView from './SchoolSelectorView';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import {
  BACKEND_EDUCATION_LIST_KEY,
  BACKEND_EDUCATION_GOAL_API,
} from '../ChildrenInfoWorkflowConstants';
import * as childrenSelector from '../ChildrenInfoWorkflowSelector';
import nextIteratorsSelector from './SchoolSelectorSelector';

const mapStateToProps = (state, ownProps) => {
  const clientId = childrenSelector.clientId(state, ownProps);
  const childFirstName = childrenSelector.getSelectedChildFirstName(state, ownProps);
  const goalsList = childrenSelector.getEducationGoalList(state, ownProps);
  const childEducationGoal = childrenSelector.getChildEducationGoal(goalsList, childFirstName);
  const isEditingGoal = !!childEducationGoal.Id;

  const userUpdateEducationType = childrenSelector.getSelectedEducationType(state, ownProps);
  const existingEducationType = childEducationGoal.EducationType;
  const isEducationTypeUpdated = userUpdateEducationType || userUpdateEducationType === 0;
  const EducationType = isEducationTypeUpdated ? userUpdateEducationType : existingEducationType;

  const updatedEducationGoalData = childrenSelector.getUpdatedEducationGoalData(state, ownProps);

  const educationGoal = {
    ...childEducationGoal,
    ...updatedEducationGoalData,
    ClientId: clientId,
    EducationType,
    Name: childFirstName,
  };

  return {
    clientId,
    selectedChildFirstName: childFirstName,
    educationTypeOptions: childrenSelector.getEducationTypeOptions(state, ownProps),
    isEditingGoal,
    educationGoal,
    nextIterators: nextIteratorsSelector(state, ownProps),
  };
};

const mapDispatchToProps = dispatch => ({
  store: (data, workflowId, clientId) => {
    const educationType = {
      [BACKEND_EDUCATION_LIST_KEY]: {
        EducationType: data,
      },
    };
    dispatch(updateSupportData(educationType, workflowId, clientId));
  },
  onPostProcess: (data, educationGoal) => ({
    [BACKEND_EDUCATION_GOAL_API]: educationGoal,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SchoolSelectorView);
